import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import GrowthMarketing from './GrowthMarketing';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Growth | Admin',
    component: (
      <AdminLayout>
        <GrowthMarketing />
      </AdminLayout>
    ),
  };
}

export default action;
